import { render } from "./Loader.vue?vue&type=template&id=14099272"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/System/Compenents/Loader/Loader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "14099272"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('14099272', __exports__)) {
    api.reload('14099272', __exports__)
  }
  
  module.hot.accept("./Loader.vue?vue&type=template&id=14099272", () => {
    api.rerender('14099272', render)
  })

}


export default __exports__